import axios from 'axios';
import qs from 'query-string';
import mockState from '@/mock-state';
import { IPost, IPagination } from './store/state';

const headers = {
	'X-Requested-With': 'XMLHttpRequest',
	'Accept': 'application/json',
}

interface ISearchParams {
	page: number;
	tags: string[];
	dates: string[];
}

interface ISearchResult {
	posts: IPost[];
	total: number;
	pagination: IPagination;
}

export const search = (searchUrl: string, params: ISearchParams): Promise<ISearchResult> => {
	const url = `${searchUrl}&${qs.stringify({
		...params,
		tags: params.tags.join(','),
		dates: params.dates.join(','),
	})}`;

	if(process.env.NODE_ENV === 'development') {
		console.log({
			params
		})
		return new Promise(res => {
			setTimeout(() => {
				res();
			}, 1500);
		})
	} else {
		history.replaceState(null, document.title, url)
		return axios.get<ISearchResult>(url, { headers })
			.then(response => {
				return response.data;
			})
			.catch(searchError => {
				console.error({
					searchError
				})
				throw searchError;
			})
	}
}